import { mode as e } from "@chakra-ui/theme-tools";
const r = {
  global: (o) => ({
    body: {
      fontFamily: "body",
      color: e("gray.800", "whiteAlpha.900")(o),
      bg: e("lightBackground", "darkBackground")(o),
      transitionProperty: "background-color",
      transitionDuration: "normal",
      lineHeight: "base",
      textStyle: "bodyMd"
    },
    "*::placeholder": {
      color: e("gray.300", "whiteAlpha.400")(o)
    },
    "*:read-only:not(:disabled)::placeholder": {
      color: e("coldGray.300", "whiteAlpha.400")(o)
    },
    "*, *::before, &::after": {
      borderColor: e("coldGray.300", "whiteAlpha.300")(o),
      wordWrap: "break-word"
    },
    a: {
      textStyle: "linkMd",
      color: "secondary.highEmphasis",
      textDecoration: "none",
      fontSize: "inherit"
    }
  })
}, a = r;
export {
  a as default
};
